import React, { Component } from "react";
import PropTypes from "prop-types";

class MobilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dimensions: { width: 0, height: 0 }
    };
  }

  handleClick(e) {
    this.props.onClick(
      this.props.number,
      this.props.index,
      e.target.offsetLeft,
      this.state.dimensions.width
    );
  }

  componentDidMount() {
    const width = this.btn.offsetWidth;
    this.setState({ dimensions: { width } });
  }

  render() {
    const { title, active } = this.props;

    return (
      <button
        ref={btn => (this.btn = btn)}
        onClick={e => {
          this.handleClick(e);
        }}
        className={active ? "ui button submitX" : "ui button submitM"}
        style={{ marginBottom: 10, width: "auto", marginRight: 10 }}
        role="button"
      >
        {title}
      </button>
    );
  }
}

MobilePage.propTypes = {
  title: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  first: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  complete: PropTypes.bool,
  active: PropTypes.bool,
  selected: PropTypes.bool,
  storeColour: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default MobilePage;



// WEBPACK FOOTER //
// ./src/components/MobilePage/index.js